import React from 'react';
import styled, { css } from 'styled-components';
import getBackgroundColor from '../get-background-color';

const getBorderColor = (theme, border) => {
  switch (border) {
    case 'top':
      return `
        border-top-width: 1px;
      `;
    case 'bottom':
      return `
        border-bottom-width: 1px;
      `;
    case 'top_and_bottom':
      return `
        border-top-width: 1px;
        border-bottom-width: 1px;
      `;
    default:
      return '';
  }
};

const StyledColor = styled.div`
  ${({ theme, $color, $customColor }) => getBackgroundColor(theme, $color, $customColor)}
  border-width: 0;
  border-style: solid;
  border-color: ${({ theme }) => theme.gray02};

  ${({ theme, $border }) => getBorderColor(theme, $border)}

  ${({ $imageClip }) => $imageClip === 'ellipse_bottom' && css`
    clip-path: ellipse(126% 100% at 48% 0%);

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      clip-path: ellipse(71% 100% at 48% 0%);
    }
  `}
`;

const Color = ({
  className,
  color,
  customColor,
  border,
  children,
  imageClip,
}) => {
  if (color) {
    return (
      <StyledColor
        className={className}
        $color={color}
        $customColor={customColor}
        $border={border}
        $imageClip={imageClip}
      >
        {children}
      </StyledColor>
    );
  }
  return <div className={className}>{children}</div>;
};

export default styled(Color)`
  ${({ $disableOnMobile }) => $disableOnMobile && css`
    @media all and (max-width: ${({ theme }) => theme.breakingpoints.md}) {
      background-color: transparent;
      border: 0;
    }
  `}
`;
